import { GtmEcommerceItem } from '../Types/GtmEcommerceItem';
import Product from '../Types/Product';

export const pushEcommerce = (data: any) => {
  try {
    window['dataLayer'] = window['dataLayer'] || [];
    window['dataLayer'].push({ ecommerce: null });
    window['dataLayer'].push(data);
  } catch (e) {
    console.log(e);
  }
};

export const dataLayerAddToCart = (
  gtmEcommerceItems: GtmEcommerceItem[]
) => {
  try {
    pushEcommerce({
      event: 'gtm_add_to_cart',
      ecommerce: {
        items: gtmEcommerceItems,
        currency: gtmEcommerceItems[0]?.currency,
        value: gtmEcommerceItems.reduce(
          (p, v) => p + (v.price ?? 0) * (v.quantity ?? 0),
          0
        ),
      },
    });
  } catch (e) {
    console.log(e);
  }
};

export const dataLayerRemoveFromCart = (
  gtmEcommerceItems: GtmEcommerceItem[]
) => {
  try {
    pushEcommerce({
      event: 'gtm_remove_from_cart',
      ecommerce: {
        items: gtmEcommerceItems,
        currency: gtmEcommerceItems[0]?.currency,
        value: gtmEcommerceItems.reduce(
          (p, v) => p + (v.price ?? 0) * (v.quantity ?? 0),
          0
        ),
      },
    });
  } catch (e) {
    console.log(e);
  }
};

export const dataLayerBeginCheckoutUpsales = (
  gtmEcommerceItems: GtmEcommerceItem[]
) => {
  try {
    pushEcommerce({
      event: 'gtm_begin_checkout_upsales',
      ecommerce: {
        items: gtmEcommerceItems,
        currency: gtmEcommerceItems[0]?.currency,
        value: gtmEcommerceItems.reduce(
          (p, v) => p + (v.price ?? 0) * (v.quantity ?? 0),
          0
        ),
      },
    });
  } catch (e) {
    console.log(e);
  }
};

export const dataLayerAddToWishlist = (
  gtmEcommerceItems: GtmEcommerceItem[],
  currency: string
) => {
  try {
    pushEcommerce({
      event: 'gtm_add_to_wishlist',
      ecommerce: {
        items: gtmEcommerceItems,
        currency: currency,
        value: gtmEcommerceItems.reduce(
          (p, v) => p + (v.price ?? 0) * (v.quantity ?? 0),
          0
        ),
      },
    });
  } catch (e) {
    console.log(e);
  }
};

export const dataLayerGtmViewCart = (cart) => {
  try {
    pushEcommerce({
      event: 'gtm_view_cart',
      ecommerce: {
        currency: cart.currency,
        value: cart.gtmGrandTotal,
        items: cart.gtmOrderRows,
      },
    });
  } catch (e) {
    console.log(e);
  }
};

export const dataLayerGtmSearch = (searchTerm: string) => {
  try {
    gtag('event', 'search', {
      search_term: searchTerm,
    });
  } catch (e) {
    console.log(e);
  }
};

export const dataLayerNewsLetterSignUp = () => {
  try {
    gtag('event', 'sign_up', {});
  } catch (e) {
    console.log(e);
  }
};

export const mapProductToGtmItem: (
  product: Product,
  additionalProps?: GtmEcommerceItem
) => GtmEcommerceItem = (product, additionalProps = {}) => {
  return {
    item_id: product.id,
    item_name: product.name,
    item_brand: product.brand,
    item_category: product.category,
    price: product.price?.price?.price,
    discount: product.price?.campaignPrice?.price,
    ...additionalProps,
  };
};
